import { NgClass } from '@angular/common';
import { Component, forwardRef } from '@angular/core';
import {
  ControlValueAccessor,
  FormsModule,
  NG_VALUE_ACCESSOR,
} from '@angular/forms';
import {
  MatBottomSheet,
  MatBottomSheetModule,
} from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { MatRippleModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { deepCopy } from '../../../utils/utils';
import { ProductFiltersBottomSheet } from '../product-filters-bottom-sheet/product-filters-bottom-sheet';
import { ProductFilters } from '../product-filters-panel/product-filters-panel';
@Component({
  selector: 'app-product-filters-button',
  imports: [
    FormsModule,
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatRippleModule,
    MatBottomSheetModule,
    NgClass,
  ],
  templateUrl: './product-filters-button.html',
  styleUrl: './product-filters-button.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ProductFiltersButton),
      multi: true,
    },
  ],
})
export class ProductFiltersButton implements ControlValueAccessor {
  constructor(private bottomSheet: MatBottomSheet) {}
  open(event: MouseEvent) {
    if (this.disabled) {
      return;
    }
    event.preventDefault();
    event.stopPropagation();
    this.bottomSheet
      .open(ProductFiltersBottomSheet, {
        data: deepCopy(this.value),
      })
      .afterDismissed()
      .subscribe((value) => {
        if (value) {
          this.value = value;
          this.onChange(this.value);
        }
      });
  }

  get isActive(): boolean {
    return (
      this.value.sizes.length > 0 ||
      this.value.color.length > 0 ||
      this.value.category_ids.length > 0
    );
  }

  value: ProductFilters = {
    sizes: [],
    color: '',
    category_ids: [],
  };

  onChange: (value: ProductFilters) => void = () => {};
  onTouched: () => void = () => {};
  writeValue(value?: ProductFilters): void {
    this.value = value || {
      sizes: [],
      color: '',
      category_ids: [],
    };
  }

  registerOnChange(fn: (value: ProductFilters) => void): void {
    this.onChange = fn; // 注册外部的变更回调
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn; // 注册外部的触摸回调
  }

  disabled: boolean = false;
  // 可选：禁用组件
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
